module.exports = __webpack_public_path__ + "static/lakeview-20dd9a92f8b610dab2fe9fe65457a30d.jpg";